<template xmlns:style="http://www.w3.org/1999/xhtml">
  <div>
    <div
      v-if="
        $store.state.users.token === '' ||
          !$store.state.myCourseInfos.isMyCourseInfosLoaded
      "
    >
      <LoadingPage />
    </div>
    <div
      v-if="
        $store.state.users.token !== '' &&
          $store.state.myCourseInfos.isMyCourseInfosLoaded
      "
      style="padding:10px;margin: 5px auto"
    >
      <h3 style="color: #3e3e3e">我报名的课程</h3>
      <van-empty
        :image="img_empty"
        description="还没有报名任何课程"
        v-if="
          current_courses.length === 0 &&
            ended_courses.length === 0 &&
            cancelled_courses.length === 0
        "
      />
      <!--当前课程栏-->
      <div
        class="currentCourse"
        v-for="(course, course_index) in current_courses"
        :key="course_index"
      >
        <van-cell-group style="border: #c5c5c5 1px solid;margin-bottom: 15px">
          <van-cell
            style="background-color: #eeeeee"
            v-if="
              course.residue - 0.0001 > 0 &&
                course.final.status !== 'PD' &&
                course.earnest.status !== 'PD'
            "
          >
            <template #title>
              <span class="custom-title"
                ><b>{{ course.name }}</b></span
              >
            </template>
            <template #right-icon>
              <van-tag type="primary" v-if="!course.pay_once">未缴定金</van-tag>
              <van-tag type="primary" v-if="course.pay_once">未缴费用</van-tag>
            </template>
          </van-cell>
          <van-cell
            style="background-color: #eeeeee"
            v-if="
              course.residue - 0.0001 > 0 &&
                (course.earnest.status === 'PD' || course.final.status === 'PD')
            "
          >
            <template #title>
              <span class="custom-title"
                ><b>{{ course.name }}</b></span
              >
            </template>
            <template #right-icon>
              <van-tag type="success">已报名</van-tag>
            </template>
          </van-cell>
          <van-cell
            style="background-color: #eeeeee"
            v-if="course.residue - 0.0001 < 0"
          >
            <template #title>
              <span class="custom-title"
                ><b>{{ course.name }}</b></span
              >
            </template>
            <template #right-icon>
              <van-tag type="success">已付全款</van-tag>
            </template>
          </van-cell>
          <div
            class="location"
            v-for="(item, index) in course.locations"
            :key="index"
          >
            <van-cell
              :title="item.location + item.course"
              icon="location-o"
              style="color: #54564c"
            >
              <template #right-icon>
                {{ item.formatted }}
              </template>
            </van-cell>
          </div>
          <!--老师联系方式-->
          <van-collapse
            v-if="course.contact !== null && course.contact !== ''"
            v-model="contact"
          >
            <van-collapse-item value="点击查看" name="contact">
              <template #title>
                <div style="color: #3e3e3e;font-weight: bold">
                  授课老师微信
                  <van-icon name="chat" color="#07c160" size="1rem" />
                </div>
              </template>
              <div>{{ course.contact }}</div>
            </van-collapse-item>
          </van-collapse>
          <div v-if="!course.free">
            <!--审核进度-->
            <van-collapse
              v-model="activeNames"
              v-if="course.final.status !== 'VR'"
            >
              <van-collapse-item
                value="展开详情"
                name="1"
                style="color: #ff180c;"
              >
                <template #title>
                  <div style="color: #3e3e3e;font-weight: bold">
                    审核项进度
                  </div>
                </template>
                <van-notice-bar left-icon="info-o" wrapable :scrollable="false">
                  <van-swipe
                    vertical
                    class="notice-swipe"
                    :autoplay="3000"
                    :show-indicators="false"
                  >
                    <van-swipe-item
                      >点击下方审核项名称即可提交相关资料，请及时处理未通过的项目；</van-swipe-item
                    >
                    <van-swipe-item
                      >如果报名时选错审核项，请点击最下方
                      <b>修改报名表</b> 重新勾选项目。</van-swipe-item
                    >
                  </van-swipe>
                </van-notice-bar>
                <!-- 支付过定金 -->
                <van-cell
                  v-if="course.earnest.status === 'PD'"
                  center
                  title="缴纳定金"
                  style="color: #54564c;"
                >
                  <template #right-icon>
                    <van-icon name="checked" color="#47BF66" size="1rem" />
                    <div style="font-size: 12px;padding-left: 0.2rem">
                      已支付
                    </div>
                  </template>
                </van-cell>
                <!-- 未支付定金 -->
                <van-cell
                  v-if="
                    course.final.status !== 'PD' &&
                      course.residue - 0.0001 > 0 &&
                      course.earnest.status === 'NO'
                  "
                  center
                  title="缴纳定金"
                  style="color: #54564c;"
                  @click="toPayEarnest(course.id)"
                >
                  <template #right-icon>
                    <van-icon name="warning" color="#FF976A" size="1rem" />
                    <div
                      style="font-size: 12px;padding-left: 0.2rem;color: red"
                    >
                      <span v-if="!course.pay_once"
                        >未缴纳定金，报名未生效</span
                      >
                      <span v-if="course.pay_once">未缴纳费用，报名未生效</span>
                    </div>
                  </template>
                </van-cell>
                <!-- 等待支付 -->
                <van-cell
                  v-if="
                    course.residue - 0.0001 > 0 &&
                      course.earnest.status === 'WT'
                  "
                  center
                  title="缴纳定金"
                  style="color: #54564c;"
                  @click="toPayEarnest(course.id)"
                >
                  <template #right-icon>
                    <van-icon name="warning" color="#FF976A" size="1rem" />
                    <div style="font-size: 12px;padding-left: 0.2rem">
                      等待支付，点击去支付
                    </div>
                  </template>
                </van-cell>
                <!-- 等待审核 -->
                <van-cell
                  v-if="course.earnest.status === 'VR'"
                  center
                  title="缴纳定金"
                  style="color: #54564c;"
                >
                  <template #right-icon>
                    <van-icon
                      center
                      name="play-circle"
                      color="#07c160"
                      size="1rem"
                    />
                    <div style="font-size: 12px;padding-left: 0.2rem">
                      正在审核，审核通过后报名生效
                    </div>
                  </template>
                </van-cell>
                <!-- 审核项状态 -->
                <div v-for="(item, index) in course.verify_list" :key="index">
                  <!-- 未提交 -->
                  <van-cell
                    center
                    :title="item.name"
                    style="color: #54564c"
                    v-if="item.status === '0'"
                    @click="toChangeVerify(item)"
                  >
                    <template #right-icon>
                      <van-icon name="warning" color="#FF976A" size="1rem" />
                      <div style="font-size: 12px;padding-left: 0.2rem">
                        未提交，请点击这里提交
                      </div>
                    </template>
                  </van-cell>
                  <!-- 正在审核 -->
                  <van-cell
                    center
                    :title="item.name"
                    style="color: #54564c"
                    v-if="item.status === '1'"
                    @click="toChangeVerify(item)"
                  >
                    <template #right-icon>
                      <van-icon
                        center
                        name="play-circle"
                        color="#07c160"
                        size="1rem"
                      />
                      <div style="font-size: 12px;padding-left: 0.2rem">
                        审核中，点击可以更改
                      </div>
                    </template>
                  </van-cell>
                  <!-- 审核通过 -->
                  <van-cell
                    center
                    :title="item.name"
                    style="color: #54564c"
                    v-if="item.status === '2'"
                  >
                    <template #right-icon>
                      <van-icon name="checked" color="#07c160" size="1rem" />
                      <div style="font-size: 12px;padding-left: 0.2rem">
                        优惠已生效
                      </div>
                    </template>
                  </van-cell>
                  <!-- 审核不通过 -->
                  <van-cell
                    center
                    :title="item.name"
                    style="color: #54564c"
                    v-if="item.status === '3'"
                    @click="toChangeVerify(item)"
                  >
                    <template #right-icon>
                      <van-icon name="clear" color="red" size="1rem" />
                      <div style="font-size: 12px;padding-left: 0.2rem">
                        未通过，请点击这里修改
                      </div>
                    </template>
                  </van-cell>
                </div>
                <!-- 发票信息状态 -->
                <div v-if="course.need_invoice && invoice_status !== null">
                  <!-- 审核不通过 -->
                  <van-cell
                    center
                    title="发票信息"
                    style="color: #54564c"
                    v-if="invoice_status.status === 'VT'"
                    @click="toChangeInvoice"
                  >
                    <template #right-icon>
                      <van-icon name="clear" color="red" size="1rem" />
                      <div style="font-size: 12px;padding-left: 0.2rem">
                        未通过，请点击这里修改
                      </div>
                    </template>
                  </van-cell>
                  <!-- 审核通过 -->
                  <van-cell
                    center
                    title="发票信息"
                    style="color: #54564c"
                    v-if="invoice_status.status === 'DO'"
                  >
                    <template #right-icon>
                      <van-icon name="checked" color="#07c160" size="1rem" />
                      <div style="font-size: 12px;padding-left: 0.2rem">
                        审核通过
                      </div>
                    </template>
                  </van-cell>
                  <!-- 审核中 -->
                  <van-cell
                    center
                    title="发票信息"
                    style="color: #54564c"
                    v-if="invoice_status.status === 'VR'"
                  >
                    <template #right-icon>
                      <van-icon
                        center
                        name="play-circle"
                        color="#07c160"
                        size="1rem"
                      />
                      <div style="font-size: 12px;padding-left: 0.2rem">
                        正在审核
                      </div>
                    </template>
                  </van-cell>
                  <!-- 未提交 -->
                  <van-cell
                    center
                    title="发票信息"
                    style="color: #54564c"
                    v-if="invoice_status.status === 'NO'"
                    @click="toChangeInvoice"
                  >
                    <template #right-icon>
                      <van-icon name="warning" color="#FF976A" size="1rem" />
                      <div style="font-size: 12px;padding-left: 0.2rem">
                        未提交，点击这里提交
                      </div>
                    </template>
                  </van-cell>
                </div>
              </van-collapse-item>
            </van-collapse>

            <!-- 审核中的尾款 -->
            <van-cell
              center
              style="color: #3e3e3e;font-weight: bold"
              v-if="course.final.status === 'VR'"
            >
              <template #label>
                <div style="color:#FF976A">审核中，暂不计入</div>
              </template>
              <template #title>
                <div v-if="course.earnest.status === 'PD'">已支付尾款</div>
                <div v-if="course.earnest.status !== 'PD'">已支付全款</div>
              </template>
              <div style="font-size: 16px;padding-left: 0.2rem;color: #c2c2c2">
                {{ course.final.total }}
              </div>
            </van-cell>

            <!--剩余应缴学费 按照条件显示一行-->
            <van-cell
              center
              title="剩余应缴学费"
              label="不含税"
              style="color: #3e3e3e;font-weight: bold"
              v-if="course.residue - 0.0001 > 0 && !course.need_invoice"
            >
              <div style="padding-left: 0.2rem">
                <span
                  style="font-size: 12px;color: #ffaa0c"
                  v-if="isVerifyLeft(course.id)"
                >
                  （惠项提交并审核通过后价格将会刷新）</span
                ><span style="font-size: 16px;color: #ff180c">{{
                  course.residue
                }}</span>
              </div>
            </van-cell>
            <van-cell
              center
              title="剩余应缴学费"
              label="含税"
              style="color: #3e3e3e;font-weight: bold"
              v-if="course.residue - 0.0001 > 0 && course.need_invoice"
            >
              <div style="padding-left: 0.2rem">
                <span
                  style="font-size: 12px;color: #ffaa0c"
                  v-if="isVerifyLeft(course.id)"
                >
                  （优惠在审核通过后生效）</span
                ><span style="font-size: 16px;color: #ff180c">{{
                  course.residue
                }}</span>
              </div>
            </van-cell>
            <van-cell
              center
              title="应缴费用计算详情"
              style="color: #3e3e3e;font-weight: bold"
              @click="viewPriceDetails(course.id)"
              >点此查看
            </van-cell>
            <!-- 已缴纳学费 -->
            <van-cell
              center
              title="已缴纳学费"
              style="color: #07c160;font-weight: bold"
              v-if="course.paid - 0.0001 > 0 && course.residue - 0.0001 > 0"
            >
              <div style="font-size: 16px;padding-left: 0.2rem;color: #07c160">
                {{ course.paid }}
              </div>
            </van-cell>
            <van-cell
              center
              title="已缴纳学费"
              label="缴费完成(含税)"
              style="color: #07c160;font-weight: bold"
              v-if="
                course.paid - 0.0001 > 0 &&
                  course.residue - 0.0001 < 0 &&
                  course.is_tax_paid
              "
            >
              <div style="font-size: 16px;padding-left: 0.2rem;color: #07c160">
                {{ course.paid }}
              </div>
            </van-cell>
            <van-cell
              center
              title="已缴纳学费"
              label="缴费完成(不含税)"
              style="color: #07c160;font-weight: bold"
              v-if="
                course.paid - 0.0001 > 0 &&
                  course.residue - 0.0001 < 0 &&
                  !course.is_tax_paid
              "
            >
              <div style="font-size: 16px;padding-left: 0.2rem;color: #07c160">
                {{ course.paid }}
              </div>
            </van-cell>

            <!--学费明细-->
            <!--            <van-collapse v-model="priceDetail">-->
            <!--              <van-collapse-item-->
            <!--                value="展开详情"-->
            <!--                :name="'detail' + course_index"-->
            <!--              >-->
            <!--                <template #title>-->
            <!--                  <div style="color: #3e3e3e;font-weight: bold">-->
            <!--                    学费计算明细-->
            <!--                  </div>-->
            <!--                </template>-->
            <!--                <van-cell-->
            <!--                  center-->
            <!--                  title="课程原价"-->
            <!--                  label="未含税价格"-->
            <!--                  style="color: #3e3e3e;font-weight: bold"-->
            <!--                >-->
            <!--                  <div-->
            <!--                    style="font-size: 16px;padding-left: 0.2rem;color: #3e3e3e"-->
            <!--                  >-->
            <!--                    {{ course.price }}-->
            <!--                  </div>-->
            <!--                </van-cell>-->
            <!--                <van-cell-->
            <!--                  center-->
            <!--                  title="已缴定金抵扣"-->
            <!--                  v-if="-->
            <!--                    course.final.status !== 'PD' &&-->
            <!--                      course.earnest.status === 'PD'-->
            <!--                  "-->
            <!--                >-->
            <!--                  <template #right-icon>-->
            <!--                    <van-icon name="checked" color="#07c160" size="1rem" />-->
            <!--                    <div-->
            <!--                      style="font-size: 14px;padding-left: 0.2rem;color: #3e3e3e;"-->
            <!--                    >-->
            <!--                      -{{ course.earnest.total }}-->
            <!--                    </div>-->
            <!--                  </template>-->
            <!--                </van-cell>-->
            <!--                <van-cell-->
            <!--                  center-->
            <!--                  title="已缴定金抵扣"-->
            <!--                  style="color: #c5c5c5"-->
            <!--                  v-if="course.earnest.status === 'VR'"-->
            <!--                >-->
            <!--                  <template #right-icon>-->
            <!--                    <van-icon name="warning" color="#FF976A" size="1rem" />-->
            <!--                    <div style="font-size: 12px;padding-left: 0.2rem">-->
            <!--                      审核通过后可抵扣{{ course.earnest.total }}-->
            <!--                    </div>-->
            <!--                  </template>-->
            <!--                </van-cell>-->
            <!--                &lt;!&ndash; 叠加优惠封顶 &ndash;&gt;-->
            <!--                <van-cell-->
            <!--                  center-->
            <!--                  :title="`叠加优惠上限￥${course.coupon_overlay_max}`"-->
            <!--                  v-if="course.is_overlay_max"-->
            <!--                >-->
            <!--                  <template #right-icon>-->
            <!--                    <van-icon name="checked" color="#07c160" size="1rem" />-->
            <!--                    <div-->
            <!--                      style="font-size: 14px;line-height: 16px;padding-left: 0.2rem;color: #3e3e3e;"-->
            <!--                    >-->
            <!--                      -{{ course.coupon_overlay_max }}-->
            <!--                    </div>-->
            <!--                  </template>-->
            <!--                </van-cell>-->

            <!--                <van-cell-->
            <!--                  center-->
            <!--                  title="限时优惠"-->
            <!--                  v-if="course.early_bird_status.is_valid === true"-->
            <!--                >-->
            <!--                  <template-->
            <!--                    #label-->
            <!--                    v-if="-->
            <!--                      course.earnest.status !== 'PD' &&-->
            <!--                        course.final.status !== 'PD' &&-->
            <!--                        course.early_bird_status.remain > 0-->
            <!--                    "-->
            <!--                  >-->
            <!--                    <div style="color:#FF976A">支付定金或全款后享受</div>-->
            <!--                  </template>-->
            <!--                  <template #right-icon>-->
            <!--                    <van-icon-->
            <!--                      v-if="-->
            <!--                        course.earnest.status === 'PD' ||-->
            <!--                          course.final.status === 'PD'-->
            <!--                      "-->
            <!--                      name="checked"-->
            <!--                      color="#07c160"-->
            <!--                      size="1rem"-->
            <!--                    />-->
            <!--                    <van-icon-->
            <!--                      v-if="-->
            <!--                        course.earnest.status !== 'PD' &&-->
            <!--                          course.final.status !== 'PD'-->
            <!--                      "-->
            <!--                      name="warning"-->
            <!--                      color="#FF976A"-->
            <!--                      size="1rem"-->
            <!--                    />-->
            <!--                    <div-->
            <!--                      style="font-size: 14px;line-height: 16px;padding-left: 0.2rem;color: #3e3e3e;"-->
            <!--                    >-->
            <!--                      -{{ course.early_bird_status.coupon }}-->
            <!--                    </div>-->
            <!--                  </template>-->
            <!--                </van-cell>-->
            <!--                <van-cell-->
            <!--                  center-->
            <!--                  title="限时优惠结束时间"-->
            <!--                  v-if="-->
            <!--                    course.early_bird_status.is_valid === true &&-->
            <!--                      course.earnest.status !== 'PD' &&-->
            <!--                      course.final.status !== 'PD' &&-->
            <!--                      course.early_bird_status.remain > 0-->
            <!--                  "-->
            <!--                >-->
            <!--                  <div-->
            <!--                    style="font-size: 14px;line-height: 16px;padding-left: 0.2rem;color: #3e3e3e;"-->
            <!--                  >-->
            <!--                    <van-count-down-->
            <!--                      :time="course.early_bird_status.remain * 1000"-->
            <!--                      format="DD天HH:mm:ss"-->
            <!--                    />-->
            <!--                  </div>-->
            <!--                </van-cell>-->
            <!--                &lt;!&ndash;联合优惠&ndash;&gt;-->
            <!--                <div v-if="!course.is_overlay_max && course.union_coupon > 0">-->
            <!--                  <van-cell center title="课程联报优惠">-->
            <!--                    <template #right-icon>-->
            <!--                      <van-icon name="checked" color="#07c160" size="1rem" />-->
            <!--                      <div-->
            <!--                        style="font-size: 14px;line-height: 16px;padding-left: 0.2rem;color: #3e3e3e;"-->
            <!--                      >-->
            <!--                        -{{ course.union_coupon }}-->
            <!--                      </div>-->
            <!--                    </template>-->
            <!--                  </van-cell>-->
            <!--                </div>-->
            <!--                &lt;!&ndash;名额优惠&ndash;&gt;-->
            <!--                <div v-if="!course.is_overlay_max">-->
            <!--                  <div-->
            <!--                    v-for="seat_status in course.seats_coupon_status"-->
            <!--                    :key="seat_status.course_id"-->
            <!--                  >-->
            <!--                    <van-cell-->
            <!--                      center-->
            <!--                      :title="seat_status.name"-->
            <!--                      v-if="seat_status.has_seats || seat_status.enable"-->
            <!--                    >-->
            <!--                      <template #right-icon>-->
            <!--                        <van-icon-->
            <!--                          v-if="seat_status.enable"-->
            <!--                          name="checked"-->
            <!--                          color="#07c160"-->
            <!--                          size="1rem"-->
            <!--                        />-->
            <!--                        <van-icon-->
            <!--                          v-if="seat_status.has_seats && !seat_status.enable"-->
            <!--                          name="warning"-->
            <!--                          color="#FF976A"-->
            <!--                          size="1rem"-->
            <!--                        />-->
            <!--                        <div-->
            <!--                          style="font-size: 14px;line-height: 16px;padding-left: 0.2rem;color: #3e3e3e;"-->
            <!--                        >-->
            <!--                          -{{ seat_status.total }}-->
            <!--                        </div>-->
            <!--                      </template>-->
            <!--                    </van-cell>-->
            <!--                    <van-cell-->
            <!--                      v-if="seat_status.has_seats && !seat_status.enable"-->
            <!--                    >-->
            <!--                      <template #default-->
            <!--                        ><div-->
            <!--                          style="font-size: 14px;line-height: 16px;padding-left: 0.2rem;color: #FF976A;"-->
            <!--                        >-->
            <!--                          名额有限，请及时缴纳定金或全款，不然优惠名额会被后来的小伙伴占用哦。-->
            <!--                        </div></template-->
            <!--                      >-->
            <!--                    </van-cell>-->
            <!--                  </div>-->
            <!--                </div>-->

            <!--                &lt;!&ndash;需审核优惠 &ndash;&gt;-->
            <!--                <div v-for="(item, index) in course.coupon_status" :key="index">-->
            <!--                  <van-cell-->
            <!--                    v-if="-->
            <!--                      (item.ignore_overlay || !course.is_overlay_max) &&-->
            <!--                        !(-->
            <!--                          (course.residue - 0.0001 < 0 ||-->
            <!--                            course.final.status === 'PD') &&-->
            <!--                          item.status !== 2-->
            <!--                        )-->
            <!--                    "-->
            <!--                    center-->
            <!--                    :title="item.name"-->
            <!--                  >-->
            <!--                    <template #right-icon>-->
            <!--                      <span-->
            <!--                        v-if="item.status !== 2 && course.final.status !== 'PD'"-->
            <!--                      >-->
            <!--                        <van-icon name="warning" color="#FF976A" size="1rem" />-->
            <!--                        <span style="font-size: 12px;padding-left: 0.2rem">-->
            <!--                          审核通过后生效-->
            <!--                        </span>-->
            <!--                      </span>-->
            <!--                      <span v-if="item.status === 2">-->
            <!--                        <van-icon name="checked" color="#07c160" size="1rem" />-->
            <!--                        <span style="font-size: 14px;padding-left: 0.2rem">-->
            <!--                          -{{ item.total }}-->
            <!--                        </span>-->
            <!--                      </span>-->
            <!--                    </template>-->
            <!--                  </van-cell>-->
            <!--                </div>-->

            <!--                <van-cell-->
            <!--                  v-if="-->
            <!--                    course.adjust_message !== null && course.adjust_price !== 0-->
            <!--                  "-->
            <!--                  center-->
            <!--                  title="价格调整"-->
            <!--                  :label="course.adjust_message"-->
            <!--                  style="color: #54564c"-->
            <!--                >-->
            <!--                  &lt;!&ndash; 使用 right-icon 插槽来自定义右侧图标 &ndash;&gt;-->
            <!--                  <template #right-icon>-->
            <!--                    <van-icon color="red" size="0.2rem" />-->
            <!--                    <div style="font-size: 14px;padding-left: 0.2rem">-->
            <!--                      {{ course.adjust_price }}-->
            <!--                    </div>-->
            <!--                  </template>-->
            <!--                </van-cell>-->
            <!--                <van-cell-->
            <!--                  v-if="-->
            <!--                    course.adjust_message2 !== null &&-->
            <!--                      course.adjust_price2 !== 0-->
            <!--                  "-->
            <!--                  center-->
            <!--                  title="价格调整"-->
            <!--                  :label="course.adjust_message2"-->
            <!--                  style="color: #54564c"-->
            <!--                >-->
            <!--                  &lt;!&ndash; 使用 right-icon 插槽来自定义右侧图标 &ndash;&gt;-->
            <!--                  <template #right-icon>-->
            <!--                    <van-icon color="red" size="0.2rem" />-->
            <!--                    <div style="font-size: 14px;padding-left: 0.2rem">-->
            <!--                      {{ course.adjust_price2 }}-->
            <!--                    </div>-->
            <!--                  </template>-->
            <!--                </van-cell>-->
            <!--                <van-cell-->
            <!--                  center-->
            <!--                  title="开票手续费(含税)"-->
            <!--                  style="color: #1989fa;"-->
            <!--                  v-if="course.need_invoice"-->
            <!--                >-->
            <!--                  &lt;!&ndash; 使用 right-icon 插槽来自定义右侧图标 &ndash;&gt;-->
            <!--                  <template #right-icon>-->
            <!--                    <van-icon color="red" size="0.2rem" />-->
            <!--                    <div-->
            <!--                      style="font-size: 14px;line-height: 16px;padding-left: 0.2rem"-->
            <!--                    >-->
            <!--                      +{{ course.tax }}-->
            <!--                    </div>-->
            <!--                  </template>-->
            <!--                </van-cell>-->
            <!--              </van-collapse-item>-->
            <!--            </van-collapse>-->
            <van-divider
              :style="{
                color: '#c5c5c5',
                borderColor: '#c5c5c5',
                padding: '0 10px'
              }"
            />
            <!--修改报名表-->
            <van-cell
              title="修改报名信息"
              is-link
              url="#/mycourse"
              style="color: #3e3e3e; background-color:#f6f6f6; font-weight: bold"
              @click="modifyCourseInfo(course.id)"
            />
            <!--缴纳定金-->
            <van-cell
              v-if="
                course.pay_once === false &&
                  course.earnest.status !== 'PD' &&
                  course.earnest.status !== 'VR' &&
                  course.final.status !== 'PD' &&
                  course.final.status !== 'VR'
              "
              title="点此缴纳定金"
              is-link
              url="#/mycourse"
              style="color: red; background-color:#f6f6f6; font-weight: bold"
              @click="toPayEarnest(course.id)"
            />
            <!--缴纳全款-->
            <van-cell
              v-if="
                course.final.status !== 'PD' && course.final.status !== 'VR'
              "
              title="点此缴纳全款"
              is-link
              url="#/mycourse"
              style="color: #3e3e3e; background-color:#f6f6f6; font-weight: bold"
              @click="toPayFinal(course.id)"
            />
          </div>

          <!--取消课程，只有未支付定金的才显示取消课程-->
          <!--          <van-cell-->
          <!--            center-->
          <!--            title="取消课程"-->
          <!--            v-if="course.earnest.status === 'NO'"-->
          <!--          >-->
          <!--            <template #right-icon>-->
          <!--              <van-switch-->
          <!--                size="20"-->
          <!--                value="checked"-->
          <!--                @input="onInput"-->
          <!--                active-color="#07c160"-->
          <!--              />-->
          <!--            </template>-->
          <!--          </van-cell>-->
        </van-cell-group>
      </div>

      <!--      &lt;!&ndash;取消或结课课程栏&ndash;&gt;-->
      <!--      <van-cell-group style="border: #c5c5c5 1px solid;margin-bottom: 15px">-->
      <!--        <van-cell style="background-color: #eeeeee">-->
      <!--          <template #title>-->
      <!--            <span class="custom-title"-->
      <!--              ><b>Grasshopper参数化系统面授课程</b></span-->
      <!--            >-->
      <!--          </template>-->
      <!--          <template #right-icon>-->
      <!--            <van-tag style="background-color: #b8b8b8 ">已结课</van-tag>-->
      <!--          </template>-->
      <!--        </van-cell>-->
      <!--        <van-cell title="深圳" icon="location-o" style="color: #54564c">-->
      <!--          <template #right-icon>-->
      <!--            2018.12.30 - 2019.1.06-->
      <!--          </template>-->
      <!--        </van-cell>-->
      <!--        <van-cell title="证书编号：" icon="idcard" value="1213456454" />-->
      <!--      </van-cell-group>-->
    </div>
    <br />
    <br />
    <MainTabBar></MainTabBar>
  </div>
</template>

<script>
import { Cell, CellGroup } from "vant";
import { Icon } from "vant";
import { Tag } from "vant";
import { Collapse, CollapseItem } from "vant";
import { NoticeBar, Empty } from "vant";
// import { Button } from "vant";
import { Divider } from "vant";
//import { CountDown } from "vant";
import { Swipe, SwipeItem } from "vant";
// import { Switch } from "vant";
import { Dialog } from "vant";

import LoadingPage from "@/components/LoadingPage";
import MainTabBar from "@/components/MainTabBar";

import { mapState } from "vuex";
import img_empty from "@/assets/imgs/empty.png";

export default {
  name: "myCourse",
  components: {
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-icon": Icon,
    "van-tag": Tag,
    "van-collapse": Collapse,
    "van-collapse-item": CollapseItem,
    "van-notice-bar": NoticeBar,
    // "van-button": Button,
    "van-divider": Divider,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    // "van-switch": Switch,
    //"van-count-down": CountDown,
    [Dialog.Component.name]: Dialog.Component,
    "van-empty": Empty,
    LoadingPage,
    MainTabBar
  },
  data() {
    return {
      img_empty,
      contact: ["contact"],
      priceDetail: [],
      activeNames: ["1"],
      checked: false
    };
  },
  computed: {
    ...mapState({
      current_courses: state => state.myCourseInfos.courseInfos.current_courses,
      ended_courses: state => state.myCourseInfos.courseInfos.ended_courses,
      cancelled_courses: state =>
        state.myCourseInfos.courseInfos.cancelled_courses,
      invoice_status: state => state.myCourseInfos.courseInfos.invoice_status
    })
  },
  methods: {
    onInput(checked) {
      Dialog.confirm({
        title: "提醒",
        message: "是否确认取消这门课程？",
        confirmButtonText: "是",
        cancelButtonText: "否"
      }).then(() => {
        this.checked = checked;
      });
    },
    viewPriceDetails(id) {
      let path = `/priceDetails/${id}`;
      this.$router.push({ path: path });
    },
    toPayEarnest(id) {
      let path = `/earnest_pay/${id}`;
      this.$router.push({ path: path });
    },
    isVerifyLeft(id) {
      let course = this.current_courses.filter(
        item => item.id === parseInt(id)
      );
      if (course.length === 0) return false;
      course = course[0];
      let is_left = false;
      course.verify_list.forEach(item => {
        if (item.status !== "2") {
          is_left = true;
        }
      });
      return is_left;
    },
    toPayFinal(id) {
      let course = null;
      this.current_courses.forEach(item => {
        if (item.id === parseInt(id)) {
          course = item;
        }
      });
      if (course.earnest.status === "VR") {
        Dialog.alert({
          message:
            "您提交的定金支付凭证还在审核当中，请您在该审核完成后再支付尾款。"
        });
        return;
      }
      if (course.verify_list.length > 0) {
        let is_left = this.isVerifyLeft(id);
        if (is_left) {
          Dialog.confirm({
            message:
              "还有优惠项目没有提交或没有通过审核，尾款支付后将视为放弃该优惠，您确定要现在支付课程尾款吗？"
          })
            .then(() => {
              let path = `/final_pay/${id}`;
              this.$router.push({ path: path });
            })
            .catch(() => {});
          return;
        }
      }
      let path = `/final_pay/${id}`;
      this.$router.push({ path: path });
    },
    toChangeVerify(item) {
      this.$router.push({ path: `/upload_voucher/${item.id}` });
    },
    toChangeInvoice() {
      this.$router.push({ name: "invoice" });
    },
    modifyCourseInfo(course_info_id) {
      this.$router
        .push({ path: `/modify_course_info/${course_info_id}` })
        .catch(err => {
          console.log(err);
        });
    }
  },

  beforeMount() {
    // 应该在每个登录才能操作的视图加上下面这句
    this.$store.dispatch("users_tokenChecker");
    this.$store.state.system.tabBarActive = "user";
    // 进页面后要更新学员报名的课程信息，所以要先把 store 重置一下
    this.$store.commit("myCourseInfos/initMyCourseInfos");
    this.$store.dispatch("myCourseInfos/getInfos");
  },

  updated() {
    if (!this.$store.state.myCourseInfos.isMyCourseInfosLoaded) {
      // beforeMount 中虽然有，但这里是为了应对刷新页面以后 token 还没有的情况下做的
      this.$store.dispatch("myCourseInfos/getInfos");
    }
  }
};
</script>

<style scoped>
.custom-title {
  margin-right: 5px;
  vertical-align: middle;
  font-size: 16px;
  color: #3e3e3e;
}
.notice-swipe {
  height: 40px;
  line-height: 20px;
}
.van-cell__value {
  color: #07c160;
}
.van-tag--success {
  background-color: #07c160;
}
</style>
